// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1aPpV","header":"PatientQuestionnaire_header__1r1ZN","info":"PatientQuestionnaire_info__2oErr"};